import { render, staticRenderFns } from "./PayeeSharesEditTable.vue?vue&type=template&id=dd502ae0&scoped=true&"
import script from "./PayeeSharesEditTable.vue?vue&type=script&lang=js&"
export * from "./PayeeSharesEditTable.vue?vue&type=script&lang=js&"
import style0 from "./PayeeSharesEditTable.vue?vue&type=style&index=0&id=dd502ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd502ae0",
  null
  
)

export default component.exports